<template>
  <div :class="classes" @click="showModal">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>

 <script>
export default {
  props: {
    classes: { type: String, default: 'hamburger-container hidden-on-desktop' },
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = this.isModalVisible ? false : true
      this.$emit('show-modal', this.isModalVisible)
    },
  },
}
</script>
